export const EVENT_URL_SEGMENTS_BY_LOCALE = {
  en: 'event',
  es: 'evento',
  pt: 'evento',
} as const satisfies Record<UserLocale, string>;

export const EVENT_URL_SEGMENTS = Array.from(
  new Set(Object.values(EVENT_URL_SEGMENTS_BY_LOCALE)).values(),
);
